import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { font } from '@styles/fonts';
import ColorWrapper, { WithColor } from '@styles/colors';

import DashboardOverviewDateRangePicker from './components/DashboardOverviewDateRangePicker';
import { scale } from '@components/frame';

interface DashboardOverviewHeaderProps extends WithColor {}

const DashboardOverviewHeader: FC<DashboardOverviewHeaderProps> = ({ C }) => {
  return (
    <View>
      <View style={{ marginBottom: scale(24) }}>
        <Text style={[font['Large Title'], { color: C('Label/Light/Primary') }]}>{i18n.t('Dashboard')}</Text>
      </View>
      <DashboardOverviewDateRangePicker />
    </View>
  );
};

export default ColorWrapper(DashboardOverviewHeader);
